import { useContext, useEffect, useState } from "react";
// import { Link, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import CryptoJS from "crypto-js";
import axiosInstance from "../Context/axiosInstance";
import { GeoContext } from "../Context/GeoContext";

export default function AccountBalance() {
  const { store } = useContext(GeoContext);
  // const { pathname } = useLocation();
  const userId = localStorage.getItem("userId");
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    let request = 0;
    const controller = new AbortController();
    let id;
    try {
      id =
        userId &&
        CryptoJS.AES.decrypt(userId, process.env.REACT_APP_SECRET_KEY).toString(
          CryptoJS.enc.Utf8,
        );
    } catch {
      id = null;
    }
    const refresh = async () => {
      const current = ++request;
      setLoading(true);
      try {
        if (!id) throw new Error("No wallet user");
        const { data } = await axiosInstance.get(`/users/${id}/wallet`, {
          params: { page: 1, pageSize: 1 },
          signal: controller.signal,
        });
        const value =
          data.balance === null || data.balance === undefined
            ? NaN
            : Number(data.balance);
        if (active && current === request)
          setBalance(Number.isFinite(value) ? value : null);
      } catch {
        if (active && current === request) setBalance(null);
      } finally {
        if (active && current === request) setLoading(false);
      }
    };

    const interceptor = axiosInstance.interceptors.response.use((response) => {
      const url = response.config?.url || "";

      if (
        active &&
        response.config?.method === "post" &&
        /\/(purchase|redeem)(?:\/|\?|$)/.test(url)
      ) {
        refresh();
      }

      return response;
    });

    refresh();

    return () => {
      active = false;
      controller.abort();
      axiosInstance.interceptors.response.eject(interceptor);
    };
  }, [userId, store?.id]);

  //   const interceptor = axiosInstance.interceptors.response.use((response) => {
  //     const url = response.config?.url || "";
  //     if (
  //       active &&
  //       response.config?.method === "post" &&
  //       /\/(purchase|redeem)(?:\?|$)/.test(url)
  //     )
  //       refresh();
  //     return response;
  //   });
  //   refresh();
  //   // window.addEventListener("focus", refresh);
  //   return () => {
  //     active = false;
  //     controller.abort();
  //     // window.removeEventListener("focus", refresh);
  //     axiosInstance.interceptors.response.eject(interceptor);
  //   };
  // }, [userId, pathname, store?.id]);

  const label = loading
    ? ""
    : balance === null
      ? "Open wallet"
      : `${store?.currency || ""} ${balance.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`.trim();

  return (
    <Link
      to="/wallet"
      title="Open wallet"
      className="block max-w-[140px] truncate rounded text-xs tabular-nums text-blue-100 hover:text-white hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
    >
      {loading ? (
        <span className="inline-flex items-center gap-1">
          <span className="animate-bounce [animation-delay:-0.3s]">.</span>
          <span className="animate-bounce [animation-delay:-0.15s]">.</span>
          <span className="animate-bounce">.</span>
        </span>
      ) : (
        <span className="animate-[fadeIn_.35s_ease-out]">{label}</span>
      )}
    </Link>
  );
}
